import {
  EMP_HISTORY_UPDATE_REQUEST,
  EMP_HISTORY_UPDATE_SUCCESS,
  EMP_HISTORY_UPDATE_FAIL,
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "Job Action",
  result: [],
  msg: "",
  error: "",
};

const UpdateEmpHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case EMP_HISTORY_UPDATE_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case EMP_HISTORY_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        result: [action.result.data],
        msg: action.msg,
        error: "",
      };
    case EMP_HISTORY_UPDATE_FAIL:
      return {
        ...state,
        loading: false,
        result: [],
        msg: action.msg,
        error: action.error,
      };
    default:
      return state;
  }
};

export default UpdateEmpHistoryReducer;
